import PrivateInformation from './PrivateInformation';

export default PrivateInformation;
